import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddBOUserToProjectRPC } from "./addBoUserToProjectRPC";

export class AddBOUserToProjectRPCClientImpl extends AddBOUserToProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddBOUserToProjectRPC.Request): Promise<LeoRPCResult<AddBOUserToProjectRPC.Response, AddBOUserToProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/AddBOUserToProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddBOUserToProjectRPC.ResponseDTO,
      AddBOUserToProjectRPC.Errors.ErrorsDTO,
      AddBOUserToProjectRPC.Response,
      AddBOUserToProjectRPC.Errors.Errors
    >(
      response,
      "bo-user-management/AddBOUserToProject",
      AddBOUserToProjectRPC.Response.fromDTO,
      AddBOUserToProjectRPC.Errors.fromDTO
    );
  }
}
